(function (angular) {
    'use strict';

    angular.module('app').factory('ViewDocumentModal', [
        '$uibModal',
        ViewDocumentModal
    ]);

    angular.module('app').controller('ViewDocumentModalCtrl', [
        '$uibModalInstance',
        'modalConfig',
        ViewDocumentModalCtrl
    ]);

    function ViewDocumentModal(
        $uibModal
    ) {
        return {
            openViewDocumentModal: openViewDocumentModal,
        };

        function openViewDocumentModal(modalConfig) {
            $uibModal.open({
                templateUrl: '/app/views/modals/viewDocumentModal.html',
                controller: 'ViewDocumentModalCtrl',
                windowClass: 'modal-full',
                controllerAs: 'vm',
                resolve: {
                    modalConfig: function () {
                        return modalConfig;
                    }
                }
            });
        }
    }

    function ViewDocumentModalCtrl(
        $uibModalInstance,
        modalConfig
    ) {
        var vm = this;

        vm.ok = ok;
        vm.cancel = cancel;
        vm.loadDocument = loadDocument;
        vm.downloadDocument = downloadDocument;

        vm.downloadingDocument = false;
        vm.model = {
            Title: modalConfig.Title,
            EnableDownload: !!modalConfig.DocumentDownload,
            DownloadFileName: modalConfig.DownloadFileName,
            DocumentId: modalConfig.DocumentId,
            DisableInlinePdf: modalConfig.DisableInlinePdf,
        };

        function loadDocument(documentId, requestSettings) {
            vm.loadingDocument = true;
            return modalConfig.DocumentLoad(documentId, requestSettings)
                .finally(function () {
                    vm.loadingDocument = false;
                });
        }

        function downloadDocument(documentId) {
            vm.downloadingDocument = true;
            return modalConfig.DocumentDownload(documentId)
                .finally(function () {
                    vm.downloadingDocument = false;
                });
        }

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})(window.angular);
